export const environment = {
  production: false,
  host: 'https://dev.agentic-system.elvoon.it',
  apiUrl: 'https://dev.agentic-system.elvoon.it/ingestion/api/v1',
  socketPath: '/ingestion/api/v1/task-socket',
  keycloak: {
    url: 'https://auth.dev.agentic-system.elvoon.it/',
    realm: 'agentic-system',
    clientId: 'backoffice-console',
  }
};

